// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.ItemPopperCell_scroll__7mfSd::-webkit-scrollbar {
  height: 8px;
}
.ItemPopperCell_scroll__7mfSd::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.ItemPopperCell_scroll__7mfSd::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.ItemPopperCell_ItemPopperCell__urzqK {
  display: flex;
  align-items: center;
  grid-column-gap: 5px;
}
.ItemPopperCell_ItemPopperCell__Trashed__splFZ {
  color: var(--borderColor);
}
.ItemPopperCell_ItemPopperCell__Trashed__splFZ svg {
  stroke: var(--borderColor);
}
.ItemPopperCell_ItemPopperCell__Trashed__splFZ svg circle {
  stroke: var(--borderColor);
}
.ItemPopperCell_ItemPopperCell__urzqK i {
  font-size: 0;
}
.ItemPopperCell_ItemPopperCell__urzqK p {
  margin: 0 !important;
}
body[dir=ltr] .ItemPopperCell_ItemPopperCell__urzqK p {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
body[dir=rtl] .ItemPopperCell_ItemPopperCell__urzqK p {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}
.ItemPopperCell_ItemPopperCell__urzqK span {
  font-size: 10px;
}

.ItemPopperCell_clickable__b5nYK {
  cursor: pointer;
}

.ItemPopperCell_popper__scvm- {
  background-color: var(--bgColor);
  padding: 19.5px;
  width: 178px;
  position: relative;
  top: 0;
}
.ItemPopperCell_popper__scvm-[data-moresize=true] {
  width: 190px;
}
body[dir=ltr] .ItemPopperCell_popper__scvm- {
  font-family: "LatoRegular", "CairoRegular", sans-serif;
}
body[dir=rtl] .ItemPopperCell_popper__scvm- {
  font-family: "CairoRegular", "LatoRegular", sans-serif;
}
.ItemPopperCell_popper__scvm-.ItemPopperCell_smallPopper__Y1yzo {
  width: auto;
}
.ItemPopperCell_popper__scvm- .ItemPopperCell_popperItemHeader__aUdXv {
  -webkit-margin-after: 15px;
          margin-block-end: 15px;
  text-transform: uppercase;
  font-size: 12px !important;
  display: flex;
  justify-content: space-between;
}
.ItemPopperCell_popper__scvm- .ItemPopperCell_popperItemHeader__aUdXv > p {
  font-size: 12px !important;
}
.ItemPopperCell_popper__scvm- .ItemPopperCell_popperItemHeader__aUdXv p {
  color: var(--mainColor);
}
.ItemPopperCell_popper__scvm- .ItemPopperCell_popperItem__\\+BBLk {
  display: flex;
  align-items: center;
  grid-column-gap: 9px;
  justify-content: space-between;
  font-size: 10px !important;
}
.ItemPopperCell_popper__scvm- .ItemPopperCell_popperItem__\\+BBLk:not(:last-child) {
  margin-bottom: 10px;
}
.ItemPopperCell_popper__scvm- .ItemPopperCell_popperItem__\\+BBLk p {
  overflow: hidden;
  text-transform: capitalize;
  text-overflow: ellipsis;
  color: var(--mainColor);
}
.ItemPopperCell_popper__scvm- button {
  font-size: 10px !important;
  text-transform: capitalize;
  margin-top: 10px;
  background-color: var(--bgColor);
  border: none;
  outline: none;
  cursor: pointer;
}
.ItemPopperCell_popper__scvm- .ItemPopperCell_seeAll__j2vLL {
  font-size: 10px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  position: relative;
  border-top: 1px solid var(--borderColor);
}
.ItemPopperCell_popper__scvm- .ItemPopperCell_seeAll__j2vLL p {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Tables/Cells/ItemPoperCell/ItemPopperCell.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,aAAA;EAEA,mBAAA;EACA,oBAAA;AAqDF;AApDE;EACE,yBAAA;AAsDJ;AArDI;EACE,0BAAA;AAuDN;AAtDM;EACE,0BAAA;AAwDR;AApDE;EACE,YAAA;AAsDJ;AApDE;EACE,oBAAA;AAsDJ;AArDI;EACE,iEAAA;AAuDN;AArDI;EACE,iEAAA;AAuDN;AApDE;EACE,eAAA;AAsDJ;;AAnDA;EACE,eAAA;AAsDF;;AAnDA;EACE,gCAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;AAsDF;AApDE;EACE,YAAA;AAsDJ;AApDE;EACE,sDDUU;AC4Cd;AApDE;EACE,sDDSW;AC6Cf;AApDE;EACE,WAAA;AAsDJ;AA7BE;EACE,0BAAA;UAAA,sBAAA;EACA,yBAAA;ED4BA,0BAAA;ECnBA,aAAA;EACA,8BAAA;AAwBJ;AAhCI;ED0BA,0BAAA;ACSJ;AAhCI;EACE,uBAAA;AAkCN;AA5BE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,8BAAA;EDUA,0BAAA;ACqBJ;AA3BI;EACE,mBAAA;AA6BN;AA3BI;EACE,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;AA6BN;AA1BE;EDJE,0BAAA;ECMA,0BAAA;EACA,gBAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AA4BJ;AA1BE;EDbE,0BAAA;ECeA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AA4BJ;AA3BI;EACE,gBAAA;AA6BN","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.ItemPopperCell {\n  display: flex;\n  // grid-column-gap: 10.5px;\n  align-items: center;\n  grid-column-gap: 5px;\n  &__Trashed {\n    color: var(--borderColor);\n    svg {\n      stroke: var(--borderColor);\n      circle {\n        stroke: var(--borderColor);\n      }\n    }\n  }\n  i {\n    font-size: 0;\n  }\n  p {\n    margin: 0 !important;\n    #{$ltr} & {\n      font-family: $latoRegular !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoRegular !important;\n    }\n  }\n  span {\n    font-size: 10px;\n  }\n}\n.clickable {\n  cursor: pointer;\n}\n\n.popper {\n  background-color: var(--bgColor);\n  padding: 19.5px;\n  width: 178px;\n  position: relative;\n  top: 0;\n\n  &[data-moresize='true'] {\n    width: 190px;\n  }\n  #{$ltr} & {\n    font-family: $latoRegular;\n  }\n  #{$rtl} & {\n    font-family: $CairoRegular;\n  }\n  &.smallPopper {\n    width: auto;\n  }\n  // &::before {\n  //   content: '';\n  //   position: absolute;\n  //   display: block;\n  //   left: 50%;\n  //   transform: translateX(-50%);\n  //   top: -14px;\n  //   border: 7px solid transparent;\n  //   border-block-end-color: var(--borderColor);\n  //   z-index: 9;\n  // }\n\n  // &::after {\n  //   content: '';\n  //   position: absolute;\n  //   display: block;\n  //   left: 50%;\n  //   transform: translate(-50%, 1px);\n  //   border: 7px solid transparent;\n  //   top: -14px;\n  //   border-block-end-color: var(--bgColor);\n  //   z-index: 9;\n  // }\n  .popperItemHeader {\n    margin-block-end: 15px;\n    text-transform: uppercase;\n    @include fontSize(12);\n    & > p {\n      @include fontSize(12);\n    }\n    p {\n      color: var(--mainColor);\n    }\n    // font-weight: bold;\n    display: flex;\n    justify-content: space-between;\n  }\n  .popperItem {\n    display: flex;\n    align-items: center;\n    grid-column-gap: 9px;\n    justify-content: space-between;\n\n    @include fontSize(10);\n    // font-weight: bold;\n    &:not(:last-child) {\n      margin-bottom: 10px;\n    }\n    p {\n      overflow: hidden;\n      text-transform: capitalize;\n      text-overflow: ellipsis;\n      color: var(--mainColor);\n    }\n  }\n  button {\n    @include fontSize(10);\n    text-transform: capitalize;\n    margin-top: 10px;\n    background-color: var(--bgColor);\n    border: none;\n    outline: none;\n    cursor: pointer;\n  }\n  .seeAll {\n    @include fontSize(10);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 10px;\n    position: relative;\n    border-top: 1px solid var(--borderColor);\n    p {\n      margin-top: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `ItemPopperCell_scroll__7mfSd`,
	"ItemPopperCell": `ItemPopperCell_ItemPopperCell__urzqK`,
	"ItemPopperCell__Trashed": `ItemPopperCell_ItemPopperCell__Trashed__splFZ`,
	"clickable": `ItemPopperCell_clickable__b5nYK`,
	"popper": `ItemPopperCell_popper__scvm-`,
	"smallPopper": `ItemPopperCell_smallPopper__Y1yzo`,
	"popperItemHeader": `ItemPopperCell_popperItemHeader__aUdXv`,
	"popperItem": `ItemPopperCell_popperItem__+BBLk`,
	"seeAll": `ItemPopperCell_seeAll__j2vLL`
};
export default ___CSS_LOADER_EXPORT___;
